module.exports = __webpack_public_path__ + "static/offline-poster-7cee9c7ed6d993c2bc323d0dd4803180.jpg";